export default __webpack_public_path__ + "static/media/bg1.0f06ad60.png";